angular.module("ainapp")
    .controller("productDetailedListController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {

            $scope.PageName = "Product Detailed List";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.filter = {
                    Keyword: "",
                    AccountKeyword:""
                }

                 $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });


                 $scope.ProductDesign = {};
            MainService.GetProductDesign().then(function (response) {
                $scope.ProductDesign = response.data;
                  $.LoadingOverlay("hide");
                 $scope.loadKendo();
            }, function (err) {
                 toastr.error("Network Error");
                   $.LoadingOverlay("hide");
            })


               
            }
            $scope.Init();

          $scope.loadKendo = function(){
              $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.ProductType = "Product";
                        
                        o.data.Keyword = $scope.filter.Keyword;
                        o.data.AccountKeyword = $scope.filter.AccountKeyword;
                        MainService.ProductDetailedList(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Name: {
                                type: "string",
                                editable: false,
                            },
                            NameAr: {
                                type: "string",
                                editable: false,
                            },
                            ProductCode: {
                                type: "string",
                                editable: false,
                            },
                            BarCode: {
                                type: "string",
                                editable: false,
                            },
                            Specification: {
                                type: "string",
                                editable: false,
                            },
                            VatType: {
                                type: "string",
                                editable: false,
                            },
                            manufacturing: {
                                type: "string",
                                editable: false,
                            },
                            Stock: {
                                type: "string",
                                editable: false,
                            },
                            YRRefNo: {
                                type: "string",
                                editable: false,
                            },
                            Order: {
                                type: "int",
                                editable: false,
                            },
                            Image: {
                                type: "string",
                                editable: false,
                            },
                            ProductType: {
                                type: "string",
                                editable: false,
                            },
                            AveragePrice: {
                                type: "number",
                                editable: false,
                            },
                            SupplierName: {
                                type: "string",
                                editable: false,
                            },
                            Model: {
                                type: "string",
                                editable: false,
                            },
                            Description: {
                                type: "string",
                                editable: false,
                            },
                            DepreciationYear: {
                                type: "string",
                                editable: false,
                            },
                            AMCCompany: {
                                type: "string",
                                editable: false,
                            },
                            WarrantyDate: {
                                type: "date",
                                editable: false,
                            },
                            SellPrice: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice1: {
                                type: "number",
                                editable: false,
                            },
                             PurchasePrice2: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice3: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice4: {
                                type: "number",
                                editable: false,
                            },
                            PurchasePrice5: {
                                type: "number",
                                editable: false,
                            },
                             SalePrice1: {
                                type: "number",
                                editable: false,
                            },
                             SalePrice2: {
                                type: "number",
                                editable: false,
                            },
                            SalePrice3: {
                                type: "number",
                                editable: false,
                            },
                            SalePrice4: {
                                type: "number",
                                editable: false,
                            },
                            SalePrice5: {
                                type: "number",
                                editable: false,
                            },
                            
                            HSCode: {
                                type: "string",
                                editable: false,
                            },
                            RecipeType: {
                                type: "string",
                                editable: false,
                            },
                            Weight: {
                                type: "number",
                                editable: false,
                            },
                            Width: {
                                type: "number",
                                editable: false,
                            },
                            Length: {
                                type: "number",
                                editable: false,
                            },
                            Height: {
                                type: "number",
                                editable: false,
                            },
                            Volume: {
                                type: "number",
                                editable: false,
                            },
                            GrossWeight: {
                                type: "number",
                                editable: false,
                            },
                            Field1: {
                                type: "string",
                                editable: false,
                            },
                            Field2: {
                                type: "string",
                                editable: false,
                            },
                            Field3: {
                                type: "string",
                                editable: false,
                            },
                            Field4: {
                                type: "string",
                                editable: false,
                            },
                            Field5: {
                                type: "string",
                                editable: false,
                            },
                            Field6: {
                                type: "string",
                                editable: false,
                            },
                            Field7: {
                                type: "string",
                                editable: false,
                            },
                            Field8: {
                                type: "string",
                                editable: false,
                            },
                            Field9: {
                                type: "string",
                                editable: false,
                            },
                            Field10: {
                                type: "string",
                                editable: false,
                            },
                            Field11: {
                                type: "string",
                                editable: false,
                            },
                            Field12: {
                                type: "string",
                                editable: false,
                            },
                            Field13: {
                                type: "string",
                                editable: false,
                            },
                            Field14: {
                                type: "string",
                                editable: false,
                            },
                            Field15: {
                                type: "string",
                                editable: false,
                            },
                            Field16: {
                                type: "date",
                                editable: false,
                            },
                            Field17: {
                                type: "date",
                                editable: false,
                            },
                            Field18: {
                                type: "date",
                                editable: false,
                            },
                            Field19: {
                                type: "date",
                                editable: false,
                            },
                            Field20: {
                                type: "date",
                                editable: false,
                            },
                            Field21: {
                                type: "number",
                                editable: false,
                            },
                            Field22: {
                                type: "number",
                                editable: false,
                            },
                            Field23: {
                                type: "number",
                                editable: false,
                            },
                            Field24: {
                                type: "number",
                                editable: false,
                            },
                            Field25: {
                                type: "number",
                                editable: false,
                            },
                            ProductTpeId: {
                                type: "int",
                                editable: false,
                            },
                            ProductColorId: {
                                type: "int",
                                editable: false,
                            },
                            ProductSizeId: {
                                type: "int",
                                editable: false,
                            },
                            "Unit.Name": {
                                type: "string",
                                editable: false,
                            },
                            "PurchaseUnit.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Country.Name": {
                                type: "string",
                                editable: false,
                            },
                            "VAT.Name": {
                                type: "string",
                                editable: false,
                            },
                            CategoryId: {
                                type: "string",
                                editable: false,
                            },
                            GroupName: {
                                type: "string",
                                editable: false,
                            },
                       
                            ProductCategoryName: {
                                type: "string",
                                editable: false,
                            },
                            "Parent.Name": {
                                type: "string",
                                editable: false,
                            },
                             "SalesAccount.Name": {
                                type: "string",
                                editable: false,
                            },
                             "PurchaseAccount.Name": {
                                type: "string",
                                editable: false,
                            },
                            "COGSAccount.Name": {
                                type: "string",
                                editable: false,
                            },
                            "InventoryAccount.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Brand.Name": {
                                type: "string",
                                editable: false,
                            },
                            "Supplier.Name": {
                                type: "string",
                                editable: false,
                            },
                            
                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [{
                    field: "BalanceValue",
                    aggregate: "sum"
                    }, {
                    field: "Balance",
                    aggregate: "sum"
                    }, ],
            });

            $scope.KendoGridOptions = {



                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "Image",
                        title: "Photo",
                        template: '<img  src="{{basePath}}{{dataItem.Image}}" style="width:30px;height:30px;" />',
                        headerTemplate: "{{LanguageData.Photo}}",
                        width: "100px"
                                    },
                    {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                         width: "100px"
                        },
                        {
                        field: "NameAr",
                        title: "NameAr",
                         width: "100px"
                        },
                         
                        {   field: "ProductCode",
                        title: "Product Code",
                         width: "100px"
                        },

                        {
                        field: "ProductType",
                        title: "Product Type",
                         width: "100px"
                        },
                        {
                        field: "ProductCategoryName",
                        title: "Category",
                        width: '200px'
                        },
                        {
                        field: "GroupName",
                        title: " Group",
                         width: "100px"
                        },
                             {
                        field: "Parent.Name",
                        title: "Parent",
                         width: "100px"
                        },
                         {
                        field: "SalesAccount.Name",
                        title: "Sales Account",
                         width: "100px"
                        },

                    {
                        field: "PurchaseAccount.Name",
                        title: "Purchase Account",
                         width: "100px"
                        },

                    {
                        field: "COGSAccount.Name",
                        title: "COGS Account",
                         width: "100px"
                        },

                    {
                        field: "InventoryAccount.Name",
                        title: "Inventory Account",
                         width: "100px"
                        },
                    {
                        field: "Brand.Name",
                        title: "Brand",
                         width: "100px"
                        },
                    {
                        field: "Country.Name",
                        title: "Country",
                         width: "100px"
                        },
                    {
                        field: "BarCode",
                        title: "Bar Code",
                         width: "100px"                          
                        },
                    {
                        field: "Unit.Name",
                        title: "Unit",
                         width: "100px"
                        },
                    {
                        field: "SellPrice",
                        title: "Sell Price",
                        template: "<div style='text-align: right'>#=kendo.toString(SellPrice, 'n')#</div>",
                         width: "100px"

                        },
                    {
                        field: "PurchasePrice",
                        title: "Purchase Price",
                        template: "<div style='text-align: right'>#=kendo.toString(PurchasePrice, 'n')#</div>",
                         width: "100px"

                        },
                    {
                        field: "Description",
                        title: "Remarks",
                         width: "100px"
                        },
                        
                     {
                        field: "DepreciationYear",
                        title: "Depreciation Year",
                         width: "100px"
                        },

                    {
                        field: "AMCCompany",
                        title: "AMC Company",
                         width: "100px"
                        },

                    {
                        field: "WarrantyDate",
                        title: "Warranty Date",
                         width: "100px"
                        },

                    
                     {
                        field: "HSCode",
                        title: "HS Code",
                         width: "100px"
                        },

                    {
                        field: "RecipeType",
                        title: "Recipe Type",
                         width: "100px"
                        },

                    {
                        field: "Weight",
                        title: "Weight",
                         width: "100px"
                        },

                    {
                        field: "Width",
                        title: "Width",
                         width: "100px"
                        },

                     {
                        field: "Length",
                        title: "Length",
                         width: "100px"
                        },

                    {
                        field: "Height",
                        title: "Height",
                         width: "100px"
                        },

                    {
                        field: "Volume",
                        title: "Volume",
                         width: "100px"
                        },

                    {
                        field: "GrossWeight",
                        title: "Gross Weight",
                         width: "100px"
                        },

                     {
                        field: "PurchaseUnit.Name",
                        title: "Purchase Unit",
                         width: "100px"
                        },

                    {
                        field: "VAT.Name",
                        title: "VAT",
                         width: "100px"
                        },
                    {
                        field: "Supplier.Name",
                        title: "Supplier",
                         width: "100px"
                        },

                    
                     {
                        field: "VatType",
                        title: "Vat Type",
                         width: "100px"
                        },

                    {
                        field: "manufacturing",
                        title: "Manufacturing",
                         width: "100px"
                        },

                    {
                        field: "Stock",
                        title: "Stock",
                         width: "100px"
                        },

                    {
                        field: "YRRefNo",
                        title: "YRRefNo",
                         width: "100px"
                        },

                     {
                        field: "Order",
                        title: "Order",
                         width: "100px"
                        },


                    {
                        field: "AveragePrice",
                        title: "Average Price",
                         width: "100px"
                        },

                    {
                        field: "SupplierName",
                        title: "Supplier Txt",
                         width: "100px"
                        },

                    {
                        field: "Model",
                        title: "Model",
                         width: "100px"
                        },

                        {
                        field: "Field1",
                        title: $scope.ProductDesign.Field1Name != null ? $scope.ProductDesign.Field1Name : "Field 1",
                         width: "100px",
                        },

                    {
                        field: "Field2",
                    title: $scope.ProductDesign.Field2Name != null ? $scope.ProductDesign.Field2Name : "Field 2",
                         width: "100px"
                        },

                    {
                        field: "Field3",
                       title: $scope.ProductDesign.Field3Name != null ? $scope.ProductDesign.Field3Name : "Field 3",
                         width: "100px"
                        },

                    {
                        field: "Field4",
                       title: $scope.ProductDesign.Field4Name != null ? $scope.ProductDesign.Field4Name : "Field 4",
                         width: "100px"
                        },

                    {
                        field: "Field5",
                      title: $scope.ProductDesign.Field5Name != null ? $scope.ProductDesign.Field5Name : "Field 5",
                         width: "100px"
                        },

                    {
                        field: "Field6",
                        title: $scope.ProductDesign.Field6Name != null ? $scope.ProductDesign.Field6Name : "Field 6",
                         width: "100px"
                        },

                     {
                        field: "Field7",
                     title: $scope.ProductDesign.Field7Name != null ? $scope.ProductDesign.Field7Name : "Field 7",
                         width: "100px"
                        },

                    {
                        field: "Field8",
                        title: $scope.ProductDesign.Field8Name != null ? $scope.ProductDesign.Field8Name : "Field 8",
                         width: "100px"
                        },

                    {
                        field: "Field9",
                       title: $scope.ProductDesign.Field9Name != null ? $scope.ProductDesign.Field9Name : "Field 9",
                         width: "100px"
                        },

                    {
                        field: "Field10",
                       title: $scope.ProductDesign.Field10Name != null ? $scope.ProductDesign.Field10Name : "Field 10",
                         width: "100px"
                        },

                    {
                        field: "Field11",
                       title: $scope.ProductDesign.Field11Name != null ? $scope.ProductDesign.Field11Name : "Field 11",
                         width: "100px"
                        },

                    {
                        field: "Field12",
                       title: $scope.ProductDesign.Field12Name != null ? $scope.ProductDesign.Field12Name : "Field 12",
                         width: "100px"
                        },

                    {
                        field: "Field13",
                   title: $scope.ProductDesign.Field13Name != null ? $scope.ProductDesign.Field13Name : "Field 13",
                         width: "100px"
                        },

                    {
                        field: "Field14",
                      title: $scope.ProductDesign.Field14Name != null ? $scope.ProductDesign.Field14Name : "Field 14",
                         width: "100px"
                        },

                    {
                        field: "Field15",
                     title: $scope.ProductDesign.Field15Name != null ? $scope.ProductDesign.Field15Name : "Field 15",
                         width: "100px"
                        },

                     {
                        field: "Field16",
                    title: $scope.ProductDesign.Field16Name != null ? $scope.ProductDesign.Field16Name : "Field 16",
                         width: "100px"
                        },

                     {
                        field: "Field17",
                       title: $scope.ProductDesign.Field17Name != null ? $scope.ProductDesign.Field17Name : "Field 17",
                         width: "100px"
                        },

                    {
                        field: "Field18",
                        title: $scope.ProductDesign.Field18Name != null ? $scope.ProductDesign.Field18Name : "Field 18",
                         width: "100px"
                        },

                     {
                        field: "Field19",
                        title: $scope.ProductDesign.Field19Name != null ? $scope.ProductDesign.Field19Name : "Field 19",
                         width: "100px"
                        },

                    {
                        field: "Field20",
                      title: $scope.ProductDesign.Field20Name != null ? $scope.ProductDesign.Field20Name : "Field 20",
                         width: "100px"
                        },

                     {
                        field: "Field21",
                        title: $scope.ProductDesign.Field21Name != null ? $scope.ProductDesign.Field21Name : "Field 21",
                         width: "100px"
                        },

                    {
                        field: "Field22",
                       title: $scope.ProductDesign.Field22Name != null ? $scope.ProductDesign.Field22Name : "Field 22",
                         width: "100px"
                        },

                     {
                        field: "Field23",
                       title: $scope.ProductDesign.Field23Name != null ? $scope.ProductDesign.Field23Name : "Field 23",
                         width: "100px"
                        },

                    {
                        field: "Field24",
                      title: $scope.ProductDesign.Field24Name != null ? $scope.ProductDesign.Field24Name : "Field 24",
                         width: "100px"
                        },

                    {
                        field: "Field25",
                       title: $scope.ProductDesign.Field25Name != null ? $scope.ProductDesign.Field25Name : "Field 25",
                         width: "100px"
                        },


                    
                    ],
            };

                $scope.search = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.refresh = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }
          }

        

           
          

        }])